import React from 'react'

export const useBrandAccountSurveysQueryKey = (
  brandAccountId: string | undefined,
) =>
  React.useMemo(
    () => ['UseBrandAccountSurveysQuery_Main', { brandAccountId }] as const,
    [brandAccountId],
  )
